<template lang="pug">
	footer.footer.is-black-ducter(:style="{ backgroundImage: 'url(' + require('@/assets/ducter_small.svg') + ')', repeat: 'repeat' }")
		.content.has-text-white
			.columns
				.column.is-4.has-text-centered
					div.is-horizontal-center
						figure.image.is-200x200
							img(src="@/assets/ducter_Blanco.png")
					h2.has-text-white.is-size-3 Ductos y Terminales
					p.has-text-center.is-size-4
						|	Av. Constituyentes No. 1080, piso 5
						|	Col. Lomas Altas, Miguel Hidalgo
						|	C.P. 11950, Ciudad de México.
				.column
					.container
						.columns
							.column.is-12
								h6.has-text-white.is-size-4 Enlaces
						.columns
							.column.is-12
								ul.has-text-white
									li
										a.is-size-4(href="https://termigas.com.mx/" rel="noreferrer" target="_blank")
											span.icon
												i.fa.fas.fa-chevron-right
											| &nbspTermigas
									li
										a.is-size-4(href="https://www.ductosdelaltiplano.mx/" rel="noreferrer" target="_blank")
											span.icon
												i.fa.fas.fa-chevron-right
											| &nbspDuctos del Altiplano
									li
										router-link.a.is-size-4(to='login')
											span.icon
												i.fa.fas.fa-chevron-right
											| &nbspSistema
				.column
					.container
						.columns
							.column.is-12
								h6.has-text-white.is-size-4 Nuestros servicios
						.columns
							.column.is-12
								ul.has-text-white
									li
										a.has-text-white.is-size-4(@click="upForm('termigas')")
											span.icon
												i.fa.fas.fa-chevron-right
											|	&nbspImportación
									li
										a.has-text-white.is-size-4(@click="upForm('irge')")
											span.icon
												i.fa.fas.fa-chevron-right
											| &nbspDespacho
									li
										a.has-text-white.is-size-4(@click="upForm('ducto')")
											span.icon
												i.fa.fas.fa-chevron-right
											| &nbspBombeo
						.columns
							.column.is-12
								h6.has-text-white.is-size-4 Nuestras redes sociales
								a.button.is-rounded.is-small.is-white.is-size-6
									span.icon.has-text-dark
										i.fab.fa-facebook-f
								|	&nbsp
								a.button.is-rounded.is-small.is-white.is-size-6
									span.icon.has-text-dark
										i.fab.fa-twitter
								|	&nbsp
								a.button.is-rounded.is-small.is-white.is-size-6
									span.icon.has-text-dark
										i.fab.fa-instagram
</template>

<script>
	export default {
		name: 'Footer',
		methods: {
			upForm(sel) {
				this.$emit('upForm', sel)
			}
		},
	}
</script>

<style scoped>
	.content ul{
		padding: 0;
		margin: 0;
		}
	.content ul li{
		list-style-type: none;
		text-align: left;
		padding: 5px;
	}
	.content ul li a{
		color: #fff;
		font-size: 18px;
	}
	.content ul li a:hover{
		color: #ddd;
	}
	li {
		width: 100%;
	}
	.is-200x200 {
		width: 200px;
		max-height: 200px;
	}
	.is-horizontal-center {
		display: flex !important;
		justify-content: center;
	}

	h2 {
		margin-top: 0 !important;
	}

	.is-black-ducter {
    background-color: #000000;
  }

</style>


// WEBPACK FOOTER //
// src/components/landing_Componentes/Footer.vue